import React from 'react';
import { Col, Row } from 'reactstrap';
import ContentLoader from 'react-content-loader';

/**
 * Skelett eines Eintrags der Projektliste.
 *
 * Der einzige Unterschied zwischen den Produkten ist die Darstellung der Liste
 * (`projectListView` in `apps/<app>/src/product.js`): Bigfoot zeigt eine
 * Tabellenzeile, Cassiopeia eine Karte. Der Aufrufer uebergibt die Variante,
 * die Komponente kennt kein Produkt.
 */
export const PROJECT_LIST_ITEM_VARIANTS = ['table', 'grid'];

// Tabellenzeile: die Zeilenproportionen haengen nur von der Viewport-Breite ab,
// nicht vom Produkt (deshalb hier parametrisiert statt zweimal geschrieben).
const TABLE_RECTS = {
    mobile: [
        { x: '1%', width: '24%' },
        { x: '26%', width: '73%' },
    ],
    desktop: [
        { x: '0%', width: '24.5%' },
        { x: '25%', width: '74.5%' },
    ],
};

const TablePlaceholder = (props) => {
    const windowSize = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const mobileView = windowSize < 575;
    const rects = mobileView ? TABLE_RECTS.mobile : TABLE_RECTS.desktop;

    return (
        <Row>
            <Col>
                <ContentLoader
                    height={mobileView ? 120 : 70}
                    width={100}
                    speed={2}
                    primarycolor="#f3f3f3"
                    secondarycolor="#ecebeb"
                    style={{ width: '100%' }}
                    {...props}
                >
                    {rects.map((rect) => (
                        <rect key={rect.x} x={rect.x} y="1%" rx="0" ry="0" height="98%" style={{ width: rect.width }} />
                    ))}
                </ContentLoader>
            </Col>
        </Row>
    );
};

const GridPlaceholder = (props) => (
    <div style={{ padding: '0 0.5rem', marginBottom: '1.5rem' }}>
        <div
            style={{
                background: '#fff',
                borderRadius: '0.375rem',
                overflow: 'hidden',
                border: '1px solid #e9ecef',
                boxShadow: '0 .125rem .25rem rgba(0,0,0,.075)',
            }}
        >
            <ContentLoader
                speed={2}
                width={330}
                height={400}
                viewBox="0 0 330 400"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
                style={{ width: '100%', height: 'auto' }}
                {...props}
            >
                {/* Thumbnail Image area */}
                <rect x="0" y="0" rx="0" ry="0" width="330" height="230" />

                {/* Badge/Rank Placeholder */}
                <rect x="15" y="245" rx="3" ry="3" width="60" height="20" />

                {/* Contestant Name / Title */}
                <rect x="15" y="275" rx="3" ry="3" width="220" height="18" />

                {/* Project Title / Subtitle */}
                <rect x="15" y="300" rx="3" ry="3" width="160" height="14" />

                {/* Short Description (multi-line placeholder) */}
                <rect x="15" y="325" rx="3" ry="3" width="300" height="10" />
                <rect x="15" y="340" rx="3" ry="3" width="250" height="10" />

                {/* Progress Bar placeholder at the bottom */}
                <rect x="15" y="365" rx="4" ry="4" width="300" height="14" />
            </ContentLoader>
        </div>
    </div>
);

const ProjectListItemPlaceholder = ({ variant = 'table', ...props }) =>
    variant === 'grid' ? <GridPlaceholder {...props} /> : <TablePlaceholder {...props} />;

export default ProjectListItemPlaceholder;
